import { createSelector } from '@reduxjs/toolkit';

// Base selector for user slice state.
export const selectUserState = (state) => state.user; // Access the user slice state

export const selectUserEmail = (state) => selectUserState(state).email;

export const selectUsername = (state) => selectUserState(state).username;

export const selectUserOrganization = (state) => selectUserState(state).organization;

export const selectUserSelectedLocationPlaceId = (state) =>
  selectUserState(state).selectedLocation.placeId;

export const selectUserSelectedLocationCity = (state) =>
  selectUserState(state).selectedLocation.city;

export const selectUserSelectedLocationState = (state) =>
  selectUserState(state).selectedLocation.state;

export const selectUserSelectedLocationLatitude = (state) =>
  selectUserState(state).selectedLocation.latitude;

export const selectUserSelectedLocationLongitude = (state) =>
  selectUserState(state).selectedLocation.longitude;

export const selectUserSelectedLocationStatus = (state) =>
  selectUserState(state).selectedLocation.status;

export const selectUserSelectedLocationSource = (state) =>
  selectUserState(state).selectedLocation.source;

// Memoized selector to get user coordinates as an array [latitude, longitude]
export const selectUserCoordinates = createSelector(
  [
    (state) => selectUserState(state).selectedLocation.latitude,
    (state) => selectUserState(state).selectedLocation.longitude,
  ],
  (latitude, longitude) => [latitude, longitude],
);

// Memoized selector to get the user's identifying information (email, username, organization)
export const selectUserIdentity = createSelector(
  [selectUserEmail, selectUsername, selectUserOrganization],
  (email, username, organization) => ({ email, username, organization }),
);

export const selectUserSelectedLocation = createSelector(
  [
    selectUserSelectedLocationPlaceId,
    selectUserSelectedLocationSource,
    selectUserSelectedLocationCity,
    selectUserSelectedLocationState,
    selectUserSelectedLocationLatitude,
    selectUserSelectedLocationLongitude,
    selectUserSelectedLocationStatus,
  ],
  (placeId, source, city, state, latitude, longitude, status) => ({
    placeId,
    source,
    city,
    state,
    latitude,
    longitude,
    status,
  }),
);
